import {
	GET_REPORTS_LAST_DATES
} from '../actions/ReportsActions.js';

const initialState = {
	reportsLastDates: {}
};

const reportsReducer = (state = initialState, action) => {
	switch (action.type) {
					case GET_REPORTS_LAST_DATES: {
						return {
							...state,
							reportsLastDates: action.reportsLastDates
						};
					}
					default: {
						return state;
					}
	}
};

export default reportsReducer;
